import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { DialogHandlerService } from '../../services/dialog-handler/dialog-handler.service';
import { ErrorMessages } from 'apps/driver-dashboardfe/src/app/shared/constants/error-messages.constant';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    errorMessageConfig = ErrorMessages;
    constructor(
        private dialogService: DialogHandlerService,
        private authService: AuthenticationService
    ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((errorInstance: any) => {
                let {
                    message = '',
                    msg = '',
                    data = null,
                    error = null,
                    status = null,
                } = errorInstance?.error;

                let errorMessage =
                    message ||
                    data?.msg ||
                    msg ||
                    'Some communication error has occurred. Please try again later.';
                if (error && typeof error === 'string') {
                    errorMessage = error;
                }
                switch (status) {
                    case 404:
                        message =
                            message ||
                            this.errorMessageConfig
                                .SERVICE_TEMPORARILY_UNAVAILABLE.message;
                        break;
                    case 500:
                        message =
                            message ||
                            this.errorMessageConfig.SERVER_ERROR.message;
                        break;
                    case 401:
                        message =
                            message ||
                            this.errorMessageConfig.UNAUTHORISED_ERROR.message;
                        break;
                    case 403:
                        message =
                            message ||
                            this.errorMessageConfig.UNAUTHORISED_ERROR.message;
                        break;
                    case 40:
                        message =
                            message ||
                            this.errorMessageConfig.SERVER_ERROR.message;
                        break;
                    case 50:
                        message =
                            message ||
                            this.errorMessageConfig.SERVER_ERROR.message;
                        break;
                    case 53:
                        message =
                            message ||
                            this.errorMessageConfig
                                .SERVICE_TEMPORARILY_UNAVAILABLE.message;
                        break;
                    case 422:
                        message =
                            message ||
                            this.errorMessageConfig
                                .SERVICE_TEMPORARILY_UNAVAILABLE.message;
                        break;
                    case 410:
                        message =
                            message ||
                            this.errorMessageConfig.UNAUTHORISED_ERROR.message;
                        break;
                    case 204:
                        message =
                            message || this.errorMessageConfig.NO_DATA.message;
                        break;
                    case 503:
                        this.dialogService.warningMessage =
                            'The dashboard is under maintenance. We will be back up soon!';
                        break;
                    default:
                        message =
                            message ||
                            this.errorMessageConfig
                                .SERVICE_TEMPORARILY_UNAVAILABLE.message;

                        break;
                }

                if (errorInstance.status == 477) {
                    const resetLink = errorInstance?.error?.error?.reset_link;
                    this.dialogService
                        .alertWithCallback({
                            title: 'Oops!',
                            message:
                                'Your password has expired. You will be redirected to the reset password page. Please reset your password to continue.',
                            errorStatus: status,
                            cancelBtnText: 'Reset Password',
                        })
                        .subscribe(() => {
                            this.authService.logOut('reset', { resetLink });
                        });
                } else if (errorInstance.status == 485) {
                    let isPopupOpen = localStorage.getItem('isCoutryPopupOpen');
                    if (isPopupOpen != 'true') {
                        localStorage.setItem('isCoutryPopupOpen', 'true');
                        this.dialogService
                            .alertWithCallback({
                                title: 'Oops!',
                                message:
                                    'We weren’t able to sign you in. Please ensure you are located in the United States before attempting to sign in again. <br><br>Still need help? Submit a ticket: <a href="https://playoctopus.com/help" target="_blank">playoctopus.com/help</a>',
                                errorStatus: status,
                            })
                            .subscribe((data) => {
                                localStorage.setItem(
                                    'isCoutryPopupOpen',
                                    'false'
                                );
                            });
                    }
                    this.authService.logOut();
                } else if (
                    errorInstance.status == 403 ||
                    (errorInstance.status == 401 &&
                        !errorInstance.url.includes('user/login') &&
                        !errorInstance.url.includes(
                            'driver/verification-request/'
                        ))
                ) {
                    this.dialogService.alert({
                        title: 'Oops!',
                        message: 'You must be logged in to view this page!',
                        errorStatus: status,
                    });
                    this.authService.logOut();
                } else {
                    if (
                        !errorInstance.url.includes('token/revoke') &&
                        !errorInstance.url.includes('driver/payment') &&
                        !errorInstance.url.includes('driver/otp') &&
                        !errorInstance.url.includes(
                            'verification-request/verify-otp'
                        ) &&
                        !errorInstance.url.includes(
                            'driver/verification-request/'
                        ) &&
                        !errorInstance.url.includes(
                            'driver/prizeout/session/'
                        ) &&
                        !errorInstance.url.includes('driver/cashout') &&
                        !errorInstance.url.includes(
                            'driver/billing_details/'
                        ) &&
                        !errorInstance.url.includes('driver/reset_password/') &&
                        !errorInstance.url.includes('user/login') &&
                        !errorInstance.url.includes('driver/file-upload')
                    ) {
                        if(!errorMessage) errorMessage = 'We weren’t able to sign you in.  <br><br>You may be trying to login from outside of the United States, or there may be another issue. If the issue persists and you are trying to login from the United States, please contact support: <a href="https://playoctopus.com/help" target="_blank">playoctopus.com/help</a>';
                        this.dialogService.alert({
                            title: 'Oops!!!',
                            message: errorMessage,
                            errorStatus: status,
                        });
                    }
                }

                console.clear();
                return throwError(() => errorInstance);
            })
        );
    }
}
